import { Routes } from '@angular/router';
import { authGuard } from '@guard/auth.guard';
import { UserRoleEnum } from '@enum/user.enum';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes'),
  },
  {
    path: 'user',
    canActivate: [authGuard],
    data: {
      role: [UserRoleEnum.ADMIN, UserRoleEnum.REVIEWER, UserRoleEnum.PREPARER],
    },
    loadChildren: () => import('./user/user.routes'),
  },
  {
    path: 'errors',
    loadChildren: () => import('./error/error.routes'),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
  { path: '**', redirectTo: 'errors/404' },
];
